import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, flatMap, catchError, map } from 'rxjs/operators';
import { combineEpics } from 'web-app/util/redux-observable';
import ChildApi from 'signin-app/api/child-api';
import { dispatchStatusMessageEvent } from '@famly/stat_ts-utils_global-messages';
import { getRestClientErrorMessage } from 'signin-app/api/clients/get-rest-client-error-message';
import { defaultErrorDuration, defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import translate from 'signin-app/helpers/translate';
import { childName as getChildName, requirePickupInfo } from 'signin-app/child/selectors';
import { hasExpectedPickupTime } from 'signin-app/groups/selectors';
import { pickupFirstName } from 'signin-app/child/check-out/selectors';
import * as Actions from './actions';
import * as Selectors from './selectors';
const checkInChild = (action$, state$) => action$.pipe(ofType(Actions.checkInChild.type), mergeMap(({ payload }) => {
    const { childId, pickupRelationId, selectedHours, selectedMinutes, newPickupRelationName, successMessage, groupId, pin, goHomeWithChildId, kinderConnectPhoto, kinderConnectSignature, kinderConnectLatitude, kinderConnectLongitude, } = payload.options;
    const state = state$.value;
    const childName = getChildName(state, { id: childId, childId });
    const requirePickup = requirePickupInfo(state, { childId });
    if (requirePickup && !goHomeWithChildId && !pickupRelationId && !newPickupRelationName) {
        dispatchStatusMessageEvent({
            message: translate('chooseWhoWillPickUp', { childName }),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkInChildFailed.action('pickupRelationId is not selected'));
    }
    // Only demanded where the site collects pickup times: the picker is hidden otherwise, so
    // there would be no way to satisfy this.
    if (requirePickup &&
        hasExpectedPickupTime(state) &&
        !goHomeWithChildId &&
        (selectedHours === undefined || selectedMinutes === undefined)) {
        dispatchStatusMessageEvent({
            message: translate('chooseWhenWillBePickedUp', { childName }),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkInChildFailed.action('pickupRelationId is not selected'));
    }
    const minutesWithZero = `0${selectedMinutes}`.slice(-2);
    const pickupTime = selectedHours !== undefined && selectedMinutes !== undefined
        ? `${selectedHours}:${minutesWithZero}`
        : '';
    const pickupName = newPickupRelationName
        ? newPickupRelationName
        : pickupFirstName(state, {
            child: {
                pickupRelationId,
                childId,
                id: childId,
            },
        });
    return ChildApi.checkIn({
        childId,
        pickupRelationId,
        pickupTime,
        newPickupRelationName,
        groupId: groupId ? groupId : undefined,
        pin,
        goHomeWithChildId,
        kinderConnectPhoto,
        kinderConnectSignature,
        kinderConnectLatitude,
        kinderConnectLongitude,
    }).pipe(flatMap(response => {
        if (successMessage !== undefined) {
            dispatchStatusMessageEvent({
                message: successMessage,
                statusType: 'Success',
                sticky: false,
                e2eId: '',
                duration: defaultSuccessDuration,
            });
        }
        return [Actions.checkInChildSuccess.action(response, pickupName)];
    }), catchError(e => {
        dispatchStatusMessageEvent({
            message: getRestClientErrorMessage(e),
            statusType: 'Error',
            sticky: false,
            e2eId: '',
            duration: defaultErrorDuration,
        });
        return of(Actions.checkInChildFailed.action(e));
    }));
}));
const onSelectedHoursChanged = (action$, state$) => action$.pipe(ofType(Actions.selectPickupHours.type), map(({ payload }) => {
    var _a, _b;
    const timeOptions = Selectors.pickupTimeOptions(state$.value);
    const minutesMin = Math.min(...((_b = (_a = timeOptions.find(time => time.hour === payload.hours)) === null || _a === void 0 ? void 0 : _a.minutes) !== null && _b !== void 0 ? _b : []));
    return Actions.selectPickupMinutes.action(minutesMin);
}));
export const checkingInOutPersonType = (checkinLoginId, relationsIds) => {
    return relationsIds.includes(checkinLoginId) ? 'parent' : 'employee';
};
export default combineEpics(checkInChild, onSelectedHoursChanged);
